<template>
    <!-- indexData.is_line 判断是否征订已结束 -->
    <div class="home" v-if="hasLoading">
        <div v-if="indexData && indexData.is_line">
            <div class="home-book-types flex mb-20 white-bg">
                <!-- 适用学制及学籍列表 PC -->
                <section v-if="!showMobileComponent" class="book-types flex-1">
                    <h2 class="book-types_label f20 bold main-cl">适用学制及学籍</h2>

                    <nav class="book-types-list">
                        <div class="book-types-item" v-for="(item, index) in indexData.book_type" :key="index">
                            <p class="book-types-item-label after relative no-line-height f18">
                                {{ item.name }}
                            </p>
                            <nav class="book-types-item-children f16">
                                <p
                                    v-for="(iten, indey) in item.Children"
                                    :key="indey"
                                    class="block pointer"
                                    @click="handelChilkBookType(iten)"
                                >
                                    {{ iten.name }} >
                                </p>
                            </nav>
                        </div>
                    </nav>
                </section>

                <!-- banner -->
                <index-banner :list="indexData.banner" />

                <!-- 右侧登录模块 PC -->
                <section v-if="!showMobileComponent" class="login-module radius-16 flex flex-col justify-between">
                    <div class="login-module-top flex flex-col items-center justify-center">
                        <img class="avatar" src="@/assets/images/defalut-avatar.png" alt="" />
                        <p class="login-module-welcome f14">
                            你好,
                            {{
                                $store.state.userInfo && $store.state.userInfo.phone
                                    ? $hidePhoneNumber($store.state.userInfo.phone)
                                    : "朋友"
                            }}
                        </p>
                        <div v-if="!$store.state.token" class="w-full flex justify-between">
                            <router-link to="/login?islogin=1">
                                <com-button class="index-module-btn f16" label="登录" />
                            </router-link>
                            <router-link to="/login">
                                <com-button class="index-module-btn f16" label="注册" />
                            </router-link>
                        </div>
                    </div>
                    <service-notice :list="indexData.notice_data" />
                </section>
            </div>

            <!-- 手机端服务公告 -->
            <div v-if="showMobileComponent" class="white-bg mb-20">
                <service-notice :list="indexData.notice_data" />
            </div>
            <section>
                <!-- 首页书籍列表模块 -->
                <index-book-module icon="icon-bianjituijian" title="编辑推荐" :bookList="indexData.recommend_book" />

                <index-book-module
                    icon="icon-xiaoxuerexiaopaihang"
                    title="小学热销排行"
                    v-if="indexData.xiao_rank"
                    :bookList="xiaoRankList"
                />

                <index-book-module
                    icon="icon-zhongxuerexiaopaihang"
                    title="中学热销排行"
                    v-if="indexData.zhong_rank"
                    :bookList="zhongRankList"
                />
            </section>
        </div>

        <div class="out-line" v-else>
            本批次已结束，已有订单用户请在 <br />
            “<router-link class="main-cl" to="/orders">我的订单</router-link>”中查看
        </div>

        <!-- 学制书籍弹窗 PC -->
        <el-dialog class="book-types-dialog" width="590px" :visible.sync="bookTypeVisible">
            <template #title>
                <div class="dialog-header f20 bold flex items-center">{{ bookTypeName }}</div>
            </template>

            <section class="dialog-content">
                <div v-for="(item, index) in bookTypeList" :key="index" class="dialog-content-item flex">
                    <p class="dialog-content-item-label f18">{{ item.name }}</p>
                    <nav class="dialog-book-list f16 flex-1 flex flex-wrap">
                        <p
                            class="dialog-book-item after relative block"
                            v-for="(iten, indey) in item.Children"
                            :key="indey"
                            @click="$router.push(`/goods/type/${iten.id}?name=${iten.name}`)"
                        >
                            {{ iten.name }}
                        </p>
                    </nav>
                </div>
            </section>
        </el-dialog>
    </div>
</template>

<script>
    import { http } from "@/apis";

    import indexBookModule from "@/components/indexBookModule";
    import indexBanner from "@/components/indexBanner";
    import serviceNotice from "@/components/serviceNotice";
    import ComButton from "@/components/ComButton";

    export default {
        name: "Home",
        components: {
            indexBookModule,
            indexBanner,
            serviceNotice,
            ComButton,
        },
        data: () => ({
            hasLoading: false,
            // 首页数据
            indexData: null,
            // 显示学制弹窗
            bookTypeVisible: false,
            // 学制书籍名称
            bookTypeName: "",
            // 学制书籍列表
            bookTypeList: [],
            // 排行榜定时器
            rankTimer: null,
            // 排行榜请求次数
            rankRequestNumber: 0,
            // 小学热销排行
            xiaoRankList: [],
            // 中学热销排行
            zhongRankList: [],
        }),
        methods: {
            /**
             * 加载首页数据
             */
            loadIndexData() {
                const result = http.index.index({
                    params: {
                        is_shop_cart_count: this.$store.state.shopCarCount * 1 ? 2 : 1,
                    },
                    settings: {
                        showToast: true,
                    },
                });

                result.instance
                    .then((res) => {
                        const { code, result } = res;
                        if (code === 1000) {
                            this.indexData = result;
                            // 手机端 公共 报刊类型列表 存到vuex（因为首页数据无法再mo-header中获取,目前解决方案就是存到 vuex）
                            this.showMobileComponent &&
                                this.$store.commit("changeBookTypeList", this.initBookTypeList());

                            this.hasLoading = true;
                            // this.$store.state.shopCartNumber = result.shop_cart_count;
                            result.shop_cart_count && this.$store.commit("changeShopCarCount", result.shop_cart_count);
                            this.xiaoRankList = result.xiao_rank;
                            this.zhongRankList = result.zhong_rank;
                            if (result.is_line && (result.xiao_rank.length == 0 || result.zhong_rank.length == 0)) {
                                this.loadIndexRank();
                            }
                        }
                    })
                    .catch((err) => {
                        console.error("loadIndexData?", err);
                    });
            },
            // 初始化移动端 bookType 数据
            initBookTypeList() {
                let arr = this.indexData.book_type;
                const index = arr.findIndex((item) => item.id === 0);

                const newArr = arr[index].Children.map((child) => ({
                    ...child,
                    name: arr[index].name + child.name,
                }));
                const list = newArr.map((item) => {
                    let arrList = [];
                    item.Children.forEach((child) => {
                        arrList.push(...child.Children);
                    });

                    return {
                        ...item,
                        Children: arrList,
                    };
                });

                arr.splice(index, 1, ...list);
                return arr;
            },
            /**
             * 点击适用学制及学籍列表选项
             */
            handelChilkBookType(data) {
                if (data.Children && data.Children.length) {
                    this.bookTypeList = data.Children;
                    this.bookTypeName = data.name;

                    this.bookTypeVisible = true;
                } else {
                    this.$router.push("/goods/type/" + data.id + "?name=" + data.name);
                }
            },

            /**
             * 加载首页排行榜
             */
            loadIndexRank() {
                const result = http.index.rank();
                result.instance
                    .then((res) => {
                        const { code, result } = res;
                        if (code === 1020) {
                            this.rankTimer = setInterval(() => {
                                this.rankRequestNumber += 1;
                                let result2 = http.index.rank();
                                result2.instance
                                    .then((res2) => {
                                        if (res2.code === 1000) {
                                            this.xiaoRankList = res2.result.xiao_rank;
                                            this.zhongRankList = res2.result.zhong_rank;
                                            clearInterval(this.rankTimer);
                                            return;
                                        }

                                        if (this.rankRequestNumber >= 5) {
                                            this.$toast("错误，结束请求");
                                            clearInterval(this.rankTimer);
                                        }
                                    })
                                    .catch((err2) => {
                                        console.error("loadIndexRank?", err2);
                                    });
                            }, 1500);
                        } else if (code === 1000) {
                            this.xiaoRankList = result.xiao_rank;
                            this.zhongRankList = result.zhong_rank;
                        }
                    })
                    .catch((err) => {
                        console.error("loadIndexData?", err);
                    });
            },
        },
        created() {
            this.loadIndexData();
        },
    };
</script>
<style lang="less" scoped>
    .out-line {
        margin: 150px auto;
        color: #999;
        font-weight: bold;
        font-size: 24px;
        text-align: center;
        line-height: 1.8;
    }

    .home-book-types {
        border-radius: 16px;
        padding: 0.3rem 0.34rem 0.56rem;

        .book-types_label {
            padding-bottom: 12px;
            border-bottom: 1px solid #c9d1d3;
        }

        // 学制、书籍列表
        .book-types-list {
            padding-top: 4px;

            .book-types-item {
                padding-top: 14px;
                padding-bottom: 16px;
                border-bottom: 1px dashed #c9d1d3;

                &:last-of-type {
                    border-bottom: 0;
                }

                &-label {
                    padding-left: 10px;
                    margin-bottom: 10px;
                    font-weight: 400;

                    &::after {
                        left: 0;
                        top: 0;
                        height: 100%;
                        width: 3px;
                        background: #d8271c;
                    }
                }

                &-children {
                    color: #878787;
                    line-height: 28px;

                    p {
                        transition: all 0.3s ease-in-out;
                        &:hover {
                            color: #d8271c;
                        }
                    }
                }
            }
        }
    }
    // 首页右侧登录模块
    .login-module {
        background: #f2f5f6;
        padding-bottom: 15px;
        width: 2.96rem;

        &-top {
            padding: 15px 0.25rem 18px;
            .avatar {
                width: 0.6rem;
                border-radius: 50%;
            }
            // border-bottom: 1px dashed #c9d1d3;
        }
        .login-module-welcome {
            margin: 8px 0 13px;
        }
        .index-module-btn {
            height: 0.4rem;
        }
    }
    // 页面弹窗
    @dialogPaddingVal: 45px;
    .book-types-dialog {
        // 重置 el-dialog 样式
        /deep/.el-dialog {
            border-radius: 16px;
            overflow: hidden;
        }
        /deep/.el-dialog__header {
            padding: 0;
        }
        /deep/.el-dialog__body {
            padding: 36px @dialogPaddingVal;
            // padding-right: @dialogPaddingVal;
        }
        /deep/.el-dialog__headerbtn .el-dialog__close {
            color: #fff;
        }
    }
    // 页面弹窗
    .book-types-dialog .dialog-header {
        height: 59px;
        color: #fff;
        background: url("../assets/images/index-dialog_bg.png") no-repeat center;
        background-size: cover;
        padding-left: @dialogPaddingVal;
    }
    .book-types-dialog .dialog-content {
        .dialog-content-item {
            color: #979797;
            margin-bottom: 26px;
            min-height: 46px;
            align-items: self-start;

            &:last-of-type {
                margin-bottom: 0;
            }

            @bookItemlineHeight: 28px;
            &-label {
                color: #000;
                line-height: @bookItemlineHeight;
                margin-right: 0.38rem;
            }

            .dialog-book-item {
                padding: 0 17px;
                line-height: @bookItemlineHeight;
                transition: all 0.3s ease-in-out;
                cursor: pointer;

                &:first-of-type,
                &:nth-of-type(4n + 1) {
                    padding-left: 0;
                }
                &:nth-of-type(4n) {
                    padding-right: 0;
                }
                &:nth-of-type(4n)::after,
                &:last-of-type::after {
                    opacity: 0;
                }
                &::after {
                    content: "/";
                    right: 0;
                    top: 50%;
                    transform: translate(50%, -50%);
                }

                &:hover {
                    color: #d8271c;
                }
            }
        }
    }

    // 轮播指示器颜色
    /deep/.swiper-container-vertical .slider-pagination-bullet.slider-pagination-bullet-active,
    /deep/.swiper-container-horizontal .slider-pagination-bullet.slider-pagination-bullet-active {
        background-color: #d8271c;
    }
    /deep/.swiper-container-vertical .slider-pagination-bullet,
    /deep/.swiper-container-horizontal .slider-pagination-bullet {
        background: #c9d1d3;
    }

    @media (max-width: 768px) {
        .home-book-types {
            border-radius: 0;
            padding: 0.3rem;
            height: 5.2rem;
        }
        .out-line {
            margin: 150px auto;
            padding: 0 15px;
            color: #999;
            font-weight: bold;
            font-size: 18px;
            text-align: center;
            line-height: 1.8;
        }
    }
</style>
